// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'nameSans', 'nameSans Fallback'"},"className":"__className_397ee7","variable":"__variable_397ee7"};